// extracted by mini-css-extract-plugin
export default {"content-wrapper":"SelectableTooltip_content-wrapper__-ntUr"};